import React from 'react';
import classnames from 'classnames';
import TextButton from 'src/components/text-button';
import Icon from 'shared/components/icon';

interface Props {
  name: string;
  className?: string;
  checked?: boolean;
  onClick: () => void;
}

const MenuItem = ({name, className, checked, onClick}: Props) => {
  const getClassName = classnames('menu-item', className, checked ? 'menu-item-selected' : '');
  return (
    <div className={getClassName}>
      <TextButton buttonName={name} color="dark-grey" onClick={onClick}>
        {checked && <Icon iconType="check" className="menu-item-selected-icon" />}
        {name}
      </TextButton>
    </div>
  );
};

export default MenuItem;
